module.exports = __webpack_public_path__ + "static/10-d591a1ee7b2120ca906d7a603e05cf33.jpg";